









































import { Vue, Component } from 'vue-property-decorator';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  CellContextMenuEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import CrearClienteModal from '@/pantallas/ClientesCanal/CrearClienteModal.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchClientesCanal } from '@/pantallas/ClientesCanal/fetchClientesCanal';

@Component({
  components: { GridComponent: AgGridVue, CrearClienteModal },
})
export default class ClientesCanal extends Vue {
  SearchFieldClient: string = '';
  readonly $snotify: any;
  readonly loadingService = new LoadingService();

  // Grid State
  gridOptions: GridOptions;
  columnDefs: Array<ColDef> = [];
  localeText: any = {};
  gridApi: GridApi;
  columnApi: ColumnApi;
  showCreateModal: boolean = false;

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'id',
        sortable: true,
        resizable: true,
        minWidth: 80,
        hide: true,
        lockPinned: true,
      },
      {
        headerName: 'Rut',
        field: 'rut',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        sort: 'desc',
      },
      {
        headerName: 'Giro',
        field: 'giro',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Dirección',
        field: 'direccion',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Calle',
        field: 'calle',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Número',
        field: 'numero',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Comuna',
        field: 'comunatexto',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Provincia',
        field: 'provinciatexto',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Región',
        field: 'regiontexto',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Teléfono 1',
        field: 'telefono1',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Teléfono 2',
        field: 'telefono2',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Usuario Creador',
        field: 'usuariocreador',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        hide: true,
      },
      {
        headerName: 'Usuario Modificador',
        field: 'usuariomodificador',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        hide: true,
      },
      {
        headerName: 'Fecha Creación',
        field: 'fechacreacion',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        hide: true,
      },
      {
        headerName: 'Fecha Modificación',
        field: 'fechamodificacion',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
        hide: true,
      },
    ];
    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50, //Solución Paginación
      cacheBlockSize: 10000, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      onGridReady: this.onGridReady,
      columnDefs: this.columnDefs,
      suppressCopyRowsToClipboard: true,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      blockLoadDebounceMillis: 350,
      columnTypes: {},
      suppressCsvExport: false,
      suppressExcelExport: true,
    };
  }

  mounted() {
    this.getClients();
  }

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }

  isExternalFilterPresent(): boolean {
    return true;
  }

  doesExternalFilterPass(node: RowNode): boolean {
    return true;
  }

  handleClickCreate() {
    this.showCreateModal = true;
  }

  async getClients() {
    this.loadingService.showLoading();
    fetchClientesCanal(
      { canal: this.getSubDomain(), userid: this.getUserID().toString() },
      'GetChannelsClient'
    )
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          let clientList = response.data.hasOwnProperty('data')
            ? response.data.data
            : [];
          this.gridApi.setRowData(clientList);
          this.gridApi.setDomLayout('autoHeight');
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA);
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Error al obtener el cliente');
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  handleCierreModalCrear() {
    this.showCreateModal = false;
    this.getClients();
  }

  handleSearchField() {
    this.gridApi.setQuickFilter(this.SearchFieldClient);
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }
  getSubDomain() {
    //let url: string = "http://qa-betterfield.gpschile.com/";
    //let url: string = "https://track3.gpschile.com/tracker";
    let url: string = window.location.href;
    // Utilizamos una expresión regular para extraer el subdominio de la URL
    var subdominio = url.match(/^(?:https?:\/\/)?([^/.]+)/i);

    // Si se encontró un subdominio, lo retornamos
    if (subdominio && subdominio.length > 1) {
      return subdominio[1].split(':')[0];
    } else {
      return ''; // No se encontró un subdominio
    }
  }
}
